(function ($) {
  const cardStyles = {
    base: {
      color: "#666666",
      lineHeight: "18px",
      fontFamily: "museosans, arial, sans-serif",
      fontSmoothing: "antialiased",
      fontWeight: "300",
      fontSize: "16px",
      "::placeholder": {
        color: "#666666",
      },
    },
    invalid: {
      color: "#b90909",
      iconColor: "#b90909",
    },
  };

  function StripeHelper(widget) {
    const usCardDetailsTestEnabled = Boolean(
      document.getElementById("us-stripe-form-section"),
    );

    this.submitText = widget.element.find(":submit").text();

    this.widget = widget;

    this.fields = {
      cardNumber: {
        className: ".js-card-number",
        showIcon: usCardDetailsTestEnabled,
        placeholder: "",
      },
      cardExpiry: {
        className: ".js-card-expiry",
      },
      cardCvc: {
        className: ".js-card-cvc",
        placeholder: "",
      },
    };

    this.displayError = function (message) {
      this.widget.element.find(".js-card-errors").text(message);
    };

    this.disableButton = function (text = this.submitText) {
      this.widget.element
        .find(".js-make-payment")
        .prop("disabled", true)
        .text(text);
    };

    this.disableForm = function (text = "Please wait...") {
      this.disableButton(text);
      this.widget.cardElements.forEach(function (input) {
        input.update({ disabled: true });
      });
    };

    this.enableForm = function () {
      this.enableButton();
      this.widget.cardElements.forEach(function (input) {
        input.update({ disabled: false });
      });
    };

    this.enableButton = function () {
      const button = this.widget.element.find(".js-make-payment");
      if (button.prop("disabled")) {
        button.prop("disabled", false).text(this.submitText);
      }
    };

    const validCardTypes = widget.options.validCardTypes.split(",");

    this.validateCardType = function (event, errorContainer) {
      if (event.complete && !validCardTypes.includes(event.brand)) {
        this.disableButton();
        errorContainer.text("Sorry we currently do not accept this card type.");
      } else {
        this.enableButton();
        if (!event.error) errorContainer.text("");
      }
    };

    this.highlightErrorFields = function (className) {
      const errorMessagePresent = $(".payment-journey-error").length;
      if (errorMessagePresent) {
        $(className)
          .removeClass("StripeElement--empty")
          .addClass("StripeElement--invalid");
      }
    };

    const cvcPlaceholderToggling = (stripeElements) => {
      const updateCvcPlaceholder = (placeholder) => {
        const cvcElement = stripeElements.getElement("cardCvc");
        cvcElement.update({ placeholder });
      };

      const handleCardNumberChange = ({ brand }) => {
        const placeholder =
          brand === "amex" ? "1234" : this.fields.cardCvc.placeholder;
        updateCvcPlaceholder(placeholder);
      };

      const cardNumberElement = stripeElements.getElement("cardNumber");
      cardNumberElement.on("change", handleCardNumberChange);
    };

    this.setupStripe = function () {
      this.widget.stripe = Stripe(this.widget.options.publishableKey);

      const stripeElements = this.widget.stripe.elements({
        fonts: [{ cssSrc: "https://use.typekit.net/sce8lry.css" }],
      });

      this.widget.cardElements = Object.keys(this.fields).map((type) => {
        const { className, ...options } = this.fields[type];
        const stripeElement = stripeElements.create(type, {
          style: cardStyles,
          ...options,
        });
        stripeElement.mount(className);

        this.highlightErrorFields(className);

        stripeElement.addEventListener("change", (event) => {
          const errorContainer = $(className).next(".error");
          if (event.error) {
            errorContainer.text(event.error.message);
          } else {
            errorContainer.text("");
          }
          if (type === "cardNumber") {
            this.validateCardType(event, errorContainer);
          }
        });

        return stripeElement;
      });

      if (usCardDetailsTestEnabled) cvcPlaceholderToggling(stripeElements);
    };
  }

  function LogPaymentFailure(result) {
    const paymentIntentId = result.error.payment_intent
      ? result.error.payment_intent.id
      : "";
    $.ajax({
      type: "POST",
      url: `${location.pathname}?step_action=log_payment_failure`,
      data: {
        payment_intent_id: paymentIntentId,
        failure_code: result.error.code,
        failure_message: result.error.message,
      },
      dataType: "json",
    });
  }

  $.widget("chopin.stripe", $.bijou.base, {
    _create() {
      const _this = this;
      const helper = new StripeHelper(this);

      helper.setupStripe();

      this.element.on("submit", (e) => {
        e.preventDefault();
        helper.disableForm();

        _this.stripe.createToken(_this.cardElements[0]).then((result) => {
          if (result.error) {
            helper.displayError(result.error.message);
            helper.enableForm();
          } else {
            _this._submitPayment(result.token);
          }
        });
      });
    },

    _submitPayment(token) {
      this.element.find("#stripe-token").val(token.id);
      this.element.off("submit");
      this.element.submit();
    },
  });

  $.widget("chopin.stripePaymentIntent", $.bijou.base, {
    _create() {
      const _this = this;
      const helper = new StripeHelper(this);

      helper.setupStripe();

      this.element.on("submit", (e) => {
        e.preventDefault();
        helper.disableForm();

        _this
          ._checkQuoteValidity()
          .then((result) => {
            if (!result.quote_purchaseable) {
              _this._submitPage();
              return;
            }
            this.stripe
              .confirmCardPayment(this.options.clientSecret, {
                payment_method: {
                  card: _this.cardElements[0],
                  billing_details: _this.element.data("billingDetails"),
                },
              })
              .then(function (result) {
                if (!result.error) {
                  _this._updateAndSubmitPage(result.paymentIntent);
                  return;
                }
                LogPaymentFailure(result);

                if (
                  result.error.code === "payment_intent_unexpected_state" &&
                  result.error.payment_intent.status === "succeeded"
                ) {
                  _this._updateAndSubmitPage(result.error.payment_intent);
                } else {
                  helper.displayError(result.error.message);
                  helper.enableForm();
                }
              });
          })
          .catch(() => {
            _this._submitPage();
          });
      });
    },

    _checkQuoteValidity() {
      return Promise.resolve(
        $.ajax({
          type: "POST",
          url: `${location.pathname}?step_action=check_quote_validity`,
          dataType: "json",
        }),
      );
    },

    _updateAndSubmitPage(paymentIntent) {
      this.element.find("#stripe-payment-intent-id").val(paymentIntent.id);
      this.element
        .find("#stripe-payment-method-id")
        .val(paymentIntent.payment_method);
      this._submitPage();
    },

    _submitPage() {
      this.element.off("submit");
      this.element.submit();
    },
  });
})(window.jQuery);
